import type { Menu } from '@ps/web-martech-cms-types';
import React, { useCallback, useState } from 'react';

import CMSMenuGraphProvider from '../../../CMSMenu/CMSMenuGraphProvider';
import CMSNavigationItem from '../../../CMSNavigation/components/CMSNavigationItem/CMSNavigationItem';

import styles from './SEOMenu.scss';
import Submenu from './components/Submenu/Submenu';

interface Props {
  seoMenu: Menu;
  seoDepth: number;
  onClick(): void;
}

const SEOMenu: React.FC<Props> = ({ seoMenu, seoDepth, onClick }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const maxDepth = seoDepth || 1;

  const openSubmenu = useCallback((index: number) => {
    setOpenIndex((currentIndex) => (currentIndex === index ? null : index));
  }, []);

  return seoMenu ? (
    <nav>
      <CMSMenuGraphProvider menu={seoMenu}>
        <ul className={styles.seoNav}>
          {seoMenu.children.map((item, index) => (
            <React.Fragment key={item.uid}>
              <li className={styles.seoItem} onClick={() => openSubmenu(index)}>
                <CMSNavigationItem
                  reference={item}
                  maxDepth={maxDepth}
                  isSeoMenu
                  menuOpen={openIndex === index}
                  onClick={onClick}
                />
              </li>
              {openIndex === index && maxDepth > 1 && <Submenu menuItemRef={item} />}
            </React.Fragment>
          ))}
        </ul>
      </CMSMenuGraphProvider>
    </nav>
  ) : null;
};

export default SEOMenu;
